import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '@components/common';
import Header from './Header';
import Footer from './Footer';
import { useGesture } from 'react-use-gesture';
import { connect } from 'react-redux';

import { DragSelectors } from '@redux/DragRedux';

const PageWrapper = styled(Box)`
  max-width: 1064px;
  margin: auto;
`;

const PageMain = styled(Box)`
  @media screen and (min-width: 1024px) {
    min-height: calc(100vh - 152px);
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    min-height: calc(100vh - 152px);
  }
  @media screen and (max-width: 767px) {
    min-height: ${props =>
      props.withAccessory ? 'calc(100vh - 168px)' : 'calc(100vh - 152px)'};
  }
`;

function Page(props) {
  const {
    children,
    title,
    renderHeaderLeftButtons,
    isDragging,
    noBorderHeader,
    renderHeaderAccessory
  } = props;

  const bind = useGesture(
    ({ event }) => {
      if (isDragging) {
        event.preventDefault();
      }
    },
    {
      domTarget: window,
      event: { passive: false, capture: false },
      drag: true,
      pinch: false,
      scroll: false,
      wheel: false,
      move: false
    }
  );

  return (
    <PageWrapper {...bind()}>
      <Header
        title={title}
        noBorder={noBorderHeader}
        renderLeft={renderHeaderLeftButtons}
        renderHeaderAccessory={renderHeaderAccessory}
      />
      <PageMain
        withAccessory={!!renderHeaderAccessory}
        flexDirection="column"
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        px={3}
      >
        {children}
      </PageMain>
      <Footer />
    </PageWrapper>
  );
}

Page.propTypes = {
  title: PropTypes.string,
  noBorderHeader: PropTypes.bool,
  children: PropTypes.node,
  isDragging: PropTypes.any,
  renderHeaderLeftButtons: PropTypes.func,
  renderHeaderAccessory: PropTypes.func
};

const mapStatesToProps = state => ({
  isDragging: DragSelectors.selectDraggingItem(state)
});

export default connect(mapStatesToProps)(Page);
